import {
  Button,
  FilledInput,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getShiabudForm,
  shiabudSubmit,
} from "../../../../redux/actions/dataActions";
import { close } from "../../../../redux/actions/modalActions";
import "./ShiabudForm.css";
const ShiabudForm = () => {
  const dispatch = useDispatch();
  const { shiabud_form, data } = useSelector((state) => state.data);
  const [amount, setAmount] = useState(null);
  const [bank, setBank] = useState(null);
  const [branch, setBranch] = useState(null);
  useEffect(() => {
    if (!shiabud_form) {
      dispatch(getShiabudForm());
    }
  }, []);
  const submitShiabud = async () => {
    if (amount && bank && branch) {
      await dispatch(
        shiabudSubmit({ DocNum: data?.id, amount, Bank: bank, branch })
      );
      dispatch(close());
    }
  };
  return (
    <div className="shiabud_form">
      {shiabud_form && (
        <>
          <div className="cust_details">
            <span> מס' הזמנה {data?.id}</span>
            <span>{shiabud_form.custName}</span>
          </div>
          <div className="form_fields">
          <TextField
            size="small"
            id="filled-basic"
            type={"number"}
            label="סכום השיעבוד"
            className="TextField"
            onChange={(e) => setAmount(e.target.value)}
            InputProps={{
              className: "input_form",
              endAdornment: <InputAdornment position="start">₪</InputAdornment>,
            }}
            variant="filled"
          />
          <TextField
            size="small"
            id="filled-basic"
            select
            label="בנק"
            className="TextField"
            onChange={(e) => {
              setBank(e.target.value);
              setBranch(null);
            }}
            InputProps={{ className: "input_form" }}
            variant="filled"
          >
            {Object.keys(shiabud_form.finalList).map((key) => (
              <MenuItem key={key} value={key}>
                {shiabud_form?.finalList[key].name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            size="small"
            id="filled-basic"
            select
            label="סניף"
            className="TextField"
            InputProps={{ className: "input_form" }}
            variant="filled"
            onChange={(e) => setBranch(e.target.value)}
          >
            {bank &&
              Object.keys(shiabud_form.finalList[bank].branches).map((key) => (
                <MenuItem key={key} value={key}>
                  {shiabud_form.finalList[bank].branches[key]}
                </MenuItem>
              ))}
          </TextField>
          </div>
        </>
      )}
      <Button
        className="submit_btn"
        variant="outlined"
        onClick={() => submitShiabud()}
      >
        שליחה
      </Button>
    </div>
  );
};

export default ShiabudForm;
